import React from 'react';
import {ListViewRenderItemProps} from './list-view-types';

export const ListViewItemContext = React.createContext<ListViewRenderItemProps<any> | null>(null);
